import { render, staticRenderFns } from "./PreferentialBlock.vue?vue&type=template&id=59e66ad7&lang=html"
import script from "./PreferentialBlock.vue?vue&type=script&lang=js"
export * from "./PreferentialBlock.vue?vue&type=script&lang=js"
import style0 from "./PreferentialBlock.vue?vue&type=style&index=0&id=59e66ad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports